import Vue from 'vue';

Vue.directive('auto-height', require('./AutoHeight.js').default);
Vue.directive('focus', require('./focus.js').default);
Vue.directive('select', require('./selectOnFocus.js').default);
/*Vue.directive('click-outside', require('./ClickOutside.js').default);*/
Vue.directive('w-resize', require('./WindowResize.js').default);
